import { useMemo } from "react";

export function useIframeStylesHook(isVisible: boolean, style?: React.CSSProperties): React.CSSProperties {
    const iframeStyles = useMemo(() => {
        return {
            height: "100%",
            width: "100%",
            ...style,
            display: isVisible ? "flex" : "none",
        };
    }, [isVisible, style]);
    
    return iframeStyles;
}
